<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
    </div>
    <div class="response-container">
      <h1>PCS 05 API Response</h1>
      <b-row>
        <b-col md="3">
          <label>Interface Name</label>
          <b-form-input
            :formatter="capitalizeAll"
            disabled
            id="interfaceName"
            name="interfaceName"
            v-model="interfaceName"
          ></b-form-input
        ></b-col>
        <b-col md="3">
          <label>BOE Number (2219940)</label>
          <b-form-input
            :formatter="capitalizeAll"
            id="boeNumber"
            name="boeNumber"
            v-model="boeNumber"
          ></b-form-input
        ></b-col>
        <b-col md="3">
          <b-button
            v-if="interfaceName && boeNumber"
            @click="getAllPCS05Func()"
            size="sm"
            variant="info"
            style="font-size: 0.675rem; margin-left: 5px; margin-bottom: 4px"
            >Fetch</b-button
          >
        </b-col>
      </b-row>
      <hr />
      <div
        v-if="
          !getAllPcs05 ||
          !getAllPcs05.response ||
          getAllPcs05.response[0].responseMsg === 'not found'
        "
      >
        <b class="text-danger">No data found.</b>
      </div>
      <div v-else-if="getAllPcs05.responseStatus === 'SUCCESS'">
        <b-row
          v-for="(entry, index) in getAllPcs05.response"
          :key="index"
          class="mt-2 mb-2"
        >
          <b-col md="3">
            <strong>Sub Line No:</strong> {{ entry.subLineNo || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Items Bill Of Entry Date:</strong>
            {{ entry.items_BillOfEntryDate || "N/A" }}
          </b-col>
          <b-col md="3"> <strong>IGM No:</strong> {{ entry.igmNo || "N/A" }} </b-col>
          <b-col md="3">
            <strong>Out of Charge No:</strong> {{ entry.out_of_charge_no || "N/A" }}
          </b-col>
          <b-col md="3"> <strong>IGM Date:</strong> {{ entry.igmDate || "N/A" }} </b-col>
          <b-col md="3">
            <strong>Number of Packages:</strong> {{ entry.numberOfPackages || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Out of Charge Date:</strong> {{ entry.out_of_charge_date || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Sub Line Number:</strong> {{ entry.sub_line_number || "N/A" }}
          </b-col>
          <b-col md="3"> <strong>Line No:</strong> {{ entry.lineNo || "N/A" }} </b-col>
          <b-col md="3">
            <strong>Line Number:</strong> {{ entry.line_number || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Bill of Entry No:</strong> {{ entry.billOfEntryNo || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Container No:</strong> {{ entry.container_no || "N/A" }}
          </b-col>
          <b-col md="3"> <strong>CHA Code:</strong> {{ entry.chaCode || "N/A" }} </b-col>
          <b-col md="3">
            <strong>Items Bill Of Entry No:</strong>
            {{ entry.items_BillOfEntryNo || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Response Message:</strong> {{ entry.responseMsg || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Items Sub Line No:</strong> {{ entry.items_SubLineNo || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Items IGM No:</strong> {{ entry.items_IgmNo || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Nature Of Cargo:</strong> {{ entry.natureOfCargo || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Items IGM Date:</strong> {{ entry.items_IgmDate || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Items Custom House Code:</strong>
            {{ entry.items_CustomHouseCode || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Custom House Code:</strong> {{ entry.customHouseCode || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Items Line Number:</strong> {{ entry.items_LineNumber || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Country of Origin:</strong> {{ entry.countryOfOrigin || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Unit of Quantity:</strong> {{ entry.unitOfQuantity || "N/A" }}
          </b-col>
          <b-col md="3">
            <strong>Bill of Entry Date:</strong> {{ entry.billOfEntryDate || "N/A" }}
          </b-col>
          <hr />
        </b-row>
      </div>
      <div v-else>
        <p>No data found.</p>
      </div>
    </div>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import { ModelListSelect } from "vue-search-select";
import UlipService from "../../services/UlipService.js";
import CustomLoader from "../common/customLoader.vue";
import { globalPermissionStatus } from "../../helper/collection.js";
export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", this.$route.path);
    if (globalPermissionStatus("Dashboard_Access") || globalPermissionStatus("ULIP")) {
      // this.getAllPCS05Func();
    } else {
      this.$router.push({
        path: "/dashboard",
      });
    }
  },

  data() {
    return {
      interfaceName: "CHPOI10",
      boeNumber: "",
      getAllPcs05: null,
      isLoading: false,
      error: false,
      code: 200,
      message: "Success",
    };
  },

  filters: {},

  mounted() {},

  beforeDestroy() {},

  destroyed() {},
  components: {
    DatePicker,
    ModelListSelect,
    CustomLoader,
  },

  methods: {
    async getAllPCS05Func() {
      let payload = {};
      this.isLoading = true;
      this.getAllPcs05 = null;

      if (this.interfaceName && this.boeNumber) {
        payload = {
          itemCode: "PCS05",
          funcUrl: "PCS/05",
          interfaceName: this.interfaceName,
          boeNumber: this.boeNumber,
        };

        payload = JSON.stringify(payload);
        UlipService.getAllUlipList(payload)
          .then((response) => {
            const { data, status, statusText } = response;
            if (status == 200 && data) {
              if (
                data.getAllPcs05.response.response &&
                data.getAllPcs05.response.response.length > 0
              ) {
                this.getAllPcs05 = data.getAllPcs05.response.response[0];
              }
              this.isLoading = false;
            }
          })
          .catch((error) => {
            console.log("Catch on getAllPcs05 Error: ", error);
          });
      }
    },
  },
};
</script>

<style scoped>
.response-container {
  padding: 20px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}

h1 {
  font-size: 24px;
  margin-bottom: 20px;
}

ul {
  list-style: none;
  padding: 0;
}

li {
  margin-bottom: 10px;
  font-size: 18px;
}

strong {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// PCS05_ResponseDisplay.vue?3aca9cb4